interface ImageData {
  src: string;
  alt: string;
  width: number;
  height: number;
}

export const PROPERTY_CARD_FALLBACK_IMAGE_URL =
  "/images/static_images/missing-property-image-fallback.png";
export const PROPERTY_MAP_FALLBACK_IMAGE_URL =
  "/images/static_images/missing-property-map-image-fallback.png";
export const PROPERTY_MAP_FALLBACK_IMAGE_BANNER_URL =
  "/images/static_images/missing-property-image-banner-fallback.png";

export const getImageSrc = (imageName: string): string => {
  return `${process.env.NEXT_PUBLIC_AemDynamicMediaUrl}${imageName}`;
};

export const aemImageLoader = ({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}) => `${src}?fmt=avif&wid=${width}&qlt=${quality ?? 90}&fit=constrain`;

export const parseImageData = (imageValue: string): ImageData | null => {
  const regex =
    /<asset.*?dmname="([^"]*?)".*?alt="([^"]*?)".*?width="(\d+)".*?height="(\d+)".*?>/;
  const match = regex.exec(imageValue);

  if (match) {
    return {
      src: getImageSrc(match[1]),
      alt: match[2],
      width: parseInt(match[3] ?? "", 10),
      height: parseInt(match[4] ?? "", 10),
    };
  }

  return null;
};
